
import { adList } from '@/api/website';
import { bargainPage } from '@/api/bargaining';
export default {
	name: 'notice_detail',
	components: {},
	data: () => {
		return {
			adList:[],
      loadingAd:true,
      bargainList:[],
		};
	},
	created() {
		this.getAdList()
    this.getBargainPage();
	},
	methods: {
    getBargainPage(){
      bargainPage({ page: 1, page_size:999}).then(res => {
        this.bargainList=res.data.list
      })
    },
		getAdList() {
			adList({ keyword: 'NS_PC_BARGAIN' }).then(res => {
        this.adList = res.data.adv_list;
        for (let i = 0; i < this.adList.length; i++) {
          if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url);
        }
        this.loadingAd = false;
      })
      .catch(err => {
        this.loadingAd = false;
      });
		},
	}
};
